/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_701caf90"]'><div :class='["modal-title-slot-demo"]'><cube-modal ref="__mpx_ref_modal__" content="我是正文正文" direction="horizontal" confirm-btn="确认继续接单" cancel-btn="取消" :mask-closable="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])'><div slot="title" :class='["modal-title-slot"]'>我是slot标题</div></cube-modal><cube-button @_click="onTap">modal-title-slot</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_701caf90"}'>
.modal-title-slot-demo
  .modal-title-slot
    margin-bottom 10px
    line-height 1.45
    font-size 22px
    font-weight bold
    color #444
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_701caf90"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_701caf90"}
  /** script content **/
  require("./modal-title-slot.mpx.js?isComponent&outputPath=components%2Fmodal-title-slot701caf90%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-title-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-title-slot701caf90%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_701caf90"],
    ctorType: "component",
    outputPath: "components/modal-title-slot701caf90/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>